import {BiUrls} from './../../biUrls';
import {Component, EventEmitter, Input, Output, ViewContainerRef} from "@angular/core";
import {MDMService} from '../services/mdmService.service';
import {ToasterComponent} from '../../../toasterComponent/toasterComponent';
import * as _ from 'underscore';

@Component({
    selector: 'dimensionEditor',
    templateUrl: 'dimensionEdit.component.html'
})

export class DimensionEditComponent {

    @Input() parent: any;
    @Input() dimensionData: any;
    @Input() recordFormat: any;
    @Input() isEdit: boolean = false;
    @Output() triggerSave = new EventEmitter();
    @Output() triggerBack = new EventEmitter();
    public saveButtonDisable: boolean = false;
    public loader: boolean = false;
    public isDimTime: boolean = false;
    public dimHierarchyLevelData: any = [];
    public dimHierarchyDataObject: any = {id: null, name: '', dimHierarchyLevelData: []};
    public recordFormatList: any = [];
    public selectedRFF: any;
    public currentDimId: number;
    public prevDimHierarchyLevelData: any = [];
    public saveButton: boolean = false;

    constructor(public dimensionService: MDMService, public toaster: ToasterComponent, vcr: ViewContainerRef) {
        this.toaster.setViewRef(vcr);
    }

    ngOnChanges() {
        if (this.parent == 'wizard') {
            this.editWizardDimension();
        } else {
            this.getDimensionById();
        }
    }

    editWizardDimension() {
        let self = this;
        // se.dimensionData
        // self.loadRecordFormat().then(res => {
        self.isEdit = true;
        self.getDimensionData();
        self.selectedRFF = self.recordFormat;
        // });

    }

    getDimensionData() {
        let self = this;
        self.isDimTime = self.dimensionData.dimTime;
        self.dimHierarchyDataObject = self.dimensionData.dimHierarchyData[0];
        for (let record of self.recordFormatList) {
            if (self.dimensionData.dimHierarchyData[0].recordFormatId == record.id) {
                self.selectedRFF = record;
                self.currentDimId = record.id;
                break;
            }
        }
        self.dimHierarchyLevelData = self.dimensionData.dimHierarchyData[0].dimHierarchyLevelData;
        self.dimHierarchyLevelData = _.sortBy(self.dimHierarchyLevelData, function (s) {
            return s.levelNumber;
        });
        self.prevDimHierarchyLevelData = self.dimHierarchyLevelData;
    }

    getDimensionById() {
        let self = this;
        self.loader = true;
        self.loadRecordFormat().then(res => {
            if (self.dimensionData.id) {
                self.isEdit = true;
                self.dimensionService.getDataById('../' + BiUrls.BI_DIMENSION, self.dimensionData.id).then((res) => {
                    if (res == undefined || res.data == undefined) {
                        self.toaster.showError('Cannot load the Dimension');
                    } else {
                        self.dimensionData = res.data;
                        self.getDimensionData();
                    }
                    self.loader = false;
                }, (error) => {
                    console.error(error);
                });
            }
            self.loader = false;
        })
    }

    public onTypeSelection(event) {
        if (event.target.value == 'time') {
            this.isDimTime = true;
            this.dimensionData.dimTime = true;
        } else {
            this.dimHierarchyLevelData.forEach(data => {
                data.levelType = null;
            })
            this.isDimTime = false;
            this.dimensionData.dimTime = false;
        }
    }

    public onSelectOfRecord(event) {
        if (event.target.value == 'selectOne') {
            this.selectedRFF = null;
            this.dimHierarchyDataObject.recordFormatId = null;
            for (let level of this.dimHierarchyLevelData) {
                level.recordFormatFieldId = null;
                level.nameFieldId = null;
                delete level.field;
                delete level.nameField;
            }
        } else {
            this.dimHierarchyDataObject.recordFormatId = null;
            this.recordFormatList.filter((item) => {
                if (event.target.value == item.id) {
                    this.selectedRFF = item;
                    this.dimHierarchyDataObject.recordFormatId = item.id;
                }
            });
        }
        if (this.dimHierarchyDataObject.recordFormatId != this.currentDimId) {
            this.dimHierarchyLevelData = [];
            this.setDimensionLevels();
        } else {
            this.dimHierarchyLevelData = this.prevDimHierarchyLevelData;
        }
    }

    setDimensionLevels() {
        let dimHierarchyLevelData;
        this.recordFormatList.filter((item) => {
            if (this.dimHierarchyDataObject.recordFormatId == item.id) {
                dimHierarchyLevelData = item.recordFormatFieldData;
                return;
            }
        });
        dimHierarchyLevelData.forEach((dimLevel) => {
            if (dimLevel.fieldDatatype == "STRING") {
                let level: any = {
                    id: null, displayName: dimLevel.displayName, levelNumber: null, levelType: null, deleted: 0,
                    dimHierarchyId: this.dimHierarchyDataObject.id, recordFormatFieldId: dimLevel.id, nameFieldId: null,
                    ordinalFieldId: null
                };
                this.dimHierarchyLevelData.push(level);
            }
        });
    }

    // public onSelectHierarchyType(event) {
    //     for (let level of this.dimHierarchyLevelData) {
    //         if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
    //             level.levelType = event.target.value;
    //         }
    //     }
    //     return;
    // }

    public OnSelectRFFields(event, fieldName) {
        let pos: any;
        let text = 'Please select field for the level';
        if (event.target.value == 'selectOne' && fieldName == 'field1') {
            this.dimHierarchyLevelData.forEach((item1) => {
                if (event.target.id == this.dimHierarchyLevelData.indexOf(item1)) {
                    item1['recordFormatFieldId'] = null;
                }
            });
            return;
        } else if (fieldName == 'field1') {
            this.dimHierarchyLevelData.forEach((item1) => {
                if (event.target.id == this.dimHierarchyLevelData.indexOf(item1)) {
                    item1['recordFormatFieldId'] = +event.target.value;
                    return;
                }
            });
        }
        if (fieldName == 'field2') {
            for (let level of this.dimHierarchyLevelData) {
                if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
                    if (fieldName == 'field1') {
                        level['recordFormatFieldId'] = event.target.value;
                    } else {
                        level.nameFieldId = event.target.value == 'selectOne' ?
                            null : event.target.value;
                    }
                }
            }
        }
        if (fieldName == 'field3') {
            for (let level of this.dimHierarchyLevelData) {
                if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
                    if (fieldName == 'field1') {
                        level['recordFormatFieldId'] = event.target.value;
                    } else {
                        level.ordinalFieldId = event.target.value == 'selectOne' ?
                            null : event.target.value;
                    }
                }
            }
        }
    }

    public onLevelDelete(event, name) {
        let self = this;
        let r = confirm('Are you sure you want to remove this level ' + name + ' ?');
        if (r == true) {
            self.toaster.showSuccess('level ' + name + ' removed successfully');
            this.dimHierarchyLevelData.splice(event.target.id, 1);
        }
    }

    public addLevels() {
        let level: any = {
            id: null, displayName: null, levelNumber: null, levelType: null, deleted: 0
        };
        if (this.isEdit) {
            level['dimHierarchyId'] = this.dimHierarchyDataObject.id;
        }
        this.dimHierarchyLevelData.push(level)
    }

    public save() {
        let self = this;
        let validate: any = this.validator();
        if (validate != '') {
            self.toaster.showError(validate);
        } else {
            if (this.parent == 'wizard') {
                self.triggerSave.emit(self.dimensionData);
            } else {

                self.saveButtonDisable = true;
                if (self.isEdit) {
                    self.dimensionService.update(BiUrls.DIMENSION, self.dimensionData).then((res) => {
                        res['type'] = 'edit';
                        self.triggerSave.emit(res);
                    });
                } else {
                    self.dimensionService.save(BiUrls.DIMENSION, self.dimensionData).then((res) => {
                        res['type'] = 'new';
                        self.triggerSave.emit(res);
                    });
                }
            }
        }
    }

    public validator() {
        if (this.dimensionData.name == undefined || this.dimensionData.name == '') {
            return 'please enter name for the dimension';
        }
        if (this.dimHierarchyDataObject.name == undefined ||
            this.dimHierarchyDataObject.name == '') {
            return 'please enter the name for hierarchy';
        }
        this.dimensionData.dimHierarchyData[0] = this.dimHierarchyDataObject;
        this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData = this.dimHierarchyLevelData;
        let str = this.levelValidator();
        if (str != '') {
            return str
        }
        this.trimer();
        return '';
    }

    public trimer() {
        this.dimensionData.name = this.dimensionData.name.trim();
        this.dimensionData.description = this.dimensionData.description != undefined ? this.dimensionData.description.trim() :
            this.dimensionData.description;
        this.dimensionData.dimHierarchyData[0].name = this.dimensionData
            .dimHierarchyData[0].name.trim();
    }

    public levelValidator() {
        for (let i = 0; i < this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData.length; i++) {
            if (this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName == undefined ||
                this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName.trim() == '') {
                return 'Please enter name for all the levels';
            }
            this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName =
                this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName.trim();
            this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].levelNumber = i;
            delete this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].field;
            delete this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].nameField
        }
        let msg = this.checkForDuplicateNameInLevels();
        if (msg != '') {
            return msg;
        }
        return '';
    }

    checkForDuplicateNameInLevels() {
        for (let level of this.dimHierarchyLevelData) {
            for (let copy of this.dimHierarchyLevelData) {
                if (copy.displayName == level.displayName && copy.levelNumber != level.levelNumber) {
                    return 'Name cannot be same for different levels';
                }
            }
        }
        return '';
    }

    public loadRecordFormat() {
        return new Promise((resolve) => {
            let self = this;
            this.dimensionService.onStartUp(BiUrls.RECORDFORMAT).then((res) => {
                self.recordFormatList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            }, (err) => {
                console.error(err);
                resolve('conpleted');
            });
        });
    }

    onBack() {
        this.triggerBack.emit();
    }

    reorder() {
        for (let k = 0; k < this.dimHierarchyLevelData.length; k++) {
            this.dimHierarchyLevelData[k].levelNumber = k;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimensionEdit.component.ts